module.exports = __webpack_public_path__ + "static/media/pauseIcon.e76f5f23.png";